import { render, staticRenderFns } from "./SpeedDial.vue?vue&type=template&id=294ca1a4&scoped=true&"
import script from "./SpeedDial.vue?vue&type=script&lang=js&"
export * from "./SpeedDial.vue?vue&type=script&lang=js&"
import style0 from "./SpeedDial.vue?vue&type=style&index=0&id=294ca1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294ca1a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VIcon,VSpeedDial})
